import React from "react"
import LoginForm from "../components/forms/loginForm"
import LayoutController from "../components/layoutController"

const Login = ({ location }) => {
  return  <LayoutController language="fi"><LoginForm location={location} /></LayoutController>
}

export default Login
